var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#96BDFB",
    fillOpacity: 0.3,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E7BF8",
    fillRule: "evenodd",
    d: "M13.355 22.878l.465-.465-4.233-4.233 9.523-9.523a2.245 2.245 0 0 1 3.175 0l1.058 1.059a2.245 2.245 0 0 1 0 3.174l-9.988 9.988zm-.599.588c-.404.343-.919.534-1.453.534H8.374A.374.374 0 0 1 8 23.626v-2.929c0-.534.19-1.049.534-1.453l4.222 4.222z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonEdit);
export default __webpack_public_path__ + "static/media/button-edit.8735b5b029f19f2db99bde15884d802b.svg";
export { ForwardRef as ReactComponent };